export class AdditionalInfoForm {

  value: string;
  optionId: number;
  type: string;

  constructor(value: string, optionId: number, type: string) {
    this.value = value;
    this.optionId = optionId;
    this.type = type;
  }
}
